import { render, staticRenderFns } from "./InvitationErrorModal.vue?vue&type=template&id=d23832d4&lang=pug"
import script from "./InvitationErrorModal.vue?vue&type=script&lang=js"
export * from "./InvitationErrorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports